import { Component, ViewEncapsulation, OnInit } from "@angular/core";


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class FooterComponent implements OnInit {

  year:any;
  icons={
    fb:'https://epione-image.s3.us-east-2.amazonaws.com/dohealth-web/icons8-facebook-f-24.png',
    ln:'https://epione-image.s3.us-east-2.amazonaws.com/dohealth-web/icons8-linkedin-30.png',
    tw:'https://epione-image.s3.us-east-2.amazonaws.com/dohealth-web/icons8-twitter-24.png',
    linkfb:'https://www.facebook.com/profile.php?id=100063483663707',
    linkln:'https://www.linkedin.com/company/dohealth/mycompany/verification/',
    linktw:'https://twitter.com/DoHealth1'
  }

  constructor() { }

  ngOnInit(): void {
    let date: Date = new Date();
    this.year= date.getFullYear();
  }
}

